<template>
	<div>
		<app-inbox-loading v-if="isDataLoading" />
		<div v-else>
			<b-row v-if="false">
				<b-col>
					<b-button class="btn-close-page float-right mb-2" @click="$emit('closePage')" v-b-tooltip.hover title="Close"><b-icon-x /></b-button>
				</b-col>
			</b-row>
			<b-card header="Subcontract Material Issue" class="mb-3">
				<b-row>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Material Issue Number" :model="model.materialIssueNumber" />
						<app-input-combobox-autocomplete :options="purchaseOrders" optionsLabel="purchaseOrderNumber" optionsKey="id" label-cols-lg="12" label="Subcontract Purchase Order" id="fieldset-purchase-order" size="sm" :model.sync="model.purchaseOrderId"   :selected="model.purchaseOrder != null ? model.purchaseOrder.purchaseOrderNumber : ''" @input="getPurchaseOrders" :isSelectMethodExists="true" @onSelectMethod="onPurchaseOrderChange" :isEditable="true" :isUpdatable="true"/>
						<app-input-datepicker :min="minDate" id="fieldset-material-issue-date" label-cols-lg="12" label="Material Issue Date" size="sm" :model.sync="model.materialIssueDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="true" :isUpdatable="true" />
						<!-- <app-input-textbox id="fieldset-revisi" label-cols-lg="12" label="Revisi" label-for="input-revisi" size="sm" :model.sync="model.revisi"  @change="updateData" :isEditable="true" :isUpdatable="true" /> -->
						<!-- <app-input-combobox-autocomplete :options="wosForSubcontractStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Work Order Supply Subcont Status" id="fieldset-wos-subcont-status" size="sm" :model.sync="model.wosSubcontStatusId"   :selected="model.wosSubcontStatus != null ? model.wosSubcontStatus.name : ''" @input="getWosForSubcontractStatuss" @change="updateData" :isEditable="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedWosSubcontStatus" :isUpdatable="true"/> -->
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorId"   :selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors" @change="updateData" :isEditable="false" :isUpdateAble="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendor" :isUpdatable="true"/>
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12" label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"  @change="updateData" :isEditable="true" :isUpdatable="true" />
					</b-col>
				</b-row>
			</b-card>

		<app-table-input-popup title="List Part" :bordered="true" :items="workOrderSupplySubContractDetails" :fields="fieldsWorkOrderSupplySubContractDetail" :busy="isDataLoading" :sort-by.sync="sortByWorkOrderSupplySubContractDetail" :sort-desc.sync="sortDescWorkOrderSupplySubContractDetail" small responsive
			@editButtonMethod="editRowDataWorkOrderSupplySubContractDetail"
			@deleteButtonMethod="deleteRowDataWorkOrderSupplySubContractDetail"
			@showPopupAddMethod="resetDataWorkOrderSupplySubContractDetail()"
			@showPopupUploadMethod="showPopupUploadWorkOrderSupplySubContractDetail()"
			@downloadMethod="downloadWorkOrderSupplySubContractDetail()"
			@addFromClipboardMethod="addFromClipboardWorkOrderSupplySubContractDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardWorkOrderSupplySubContractDetail()"
			:showActionButton="true"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadWorkOrderSupplySubContractDetail"
			>
			<template #top-row v-if="isShowWorkOrderSupplySubContractDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
							<b-th stacked-heading="Part Number">
								<v-select append-to-body label="partNumber" :options="parts"  :value="filterWorkOrderSupplySubContractDetail.partId" :reduce="item => item.id" v-model="filterWorkOrderSupplySubContractDetail.partId" @search="getParts" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Qty PO Outstanding">
								<b-form-input id="input-qty-outstanding-table" v-model="filterWorkOrderSupplySubContractDetail.qtyOutstanding" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Stock di Vendor">
								<b-form-input id="input-stock-vendor-table" v-model="filterWorkOrderSupplySubContractDetail.stockVendor" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Suggest Supply Qty">
								<b-form-input id="input-suggest-qty-table" v-model="filterWorkOrderSupplySubContractDetail.suggestQty" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Actual Supply Qty">
								<b-form-input id="input-actual-qty-table" v-model="filterWorkOrderSupplySubContractDetail.actualQty" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Remarks">
								<b-form-input id="input-remarks-table" v-model="filterWorkOrderSupplySubContractDetail.remarks" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Actual Qty Picking">
								<b-form-input id="input-actual-qty-picking-table" v-model="filterWorkOrderSupplySubContractDetail.actualQtyPicking" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Qty PO">
								<b-form-input id="input-qty-po-table" v-model="filterWorkOrderSupplySubContractDetail.qtyPo" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Part Subcont">
								<v-select append-to-body label="partNumber" :options="parts"  :value="filterWorkOrderSupplySubContractDetail.partSubcontId" :reduce="item => item.id" v-model="filterWorkOrderSupplySubContractDetail.partSubcontId" @search="getParts" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Part Mapping Subcont">
								<v-select append-to-body label="part" :options="partMappingSubcontracts"  :value="filterWorkOrderSupplySubContractDetail.partMappingSubcontId" :reduce="item => item.id" v-model="filterWorkOrderSupplySubContractDetail.partMappingSubcontId" @search="getPartMappingSubcontracts" :filterable="true"></v-select>
							</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( workOrderSupplySubContractDetailPageSize * (currentWorkOrderSupplySubContractDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								<template v-slot:cell(part)="row">
									<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-work-order-supply-sub-contract-detail-part-' + row.index" label-cols-lg="12" label="Part Number" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isEditable="false"  :isUpdatable="false" :nolabel="true"  />
								</template>
								<template v-slot:cell(partName)="row">
									<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
								</template>
								<template v-slot:cell(partNumberWip)="row">
									<app-label label-cols-lg="12" size="sm" label="Part Number WIP" :id="'input-work-order-supply-sub-contract-detail-part-number-wip-' + row.index" :model="(row.item.partSubcont != null) ? row.item.partSubcont.partNumber : null"  />
								</template>
								<template v-slot:cell(qtyOutstanding)="row">
									<app-input-textbox :thousandSeparator="true" :id="'input-work-order-supply-sub-contract-detail-qty-outstanding-' + row.index" label-cols-lg="12" label="Qty PO Outstanding" size="sm" :model.sync="row.item.qtyOutstanding"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isEditable="false"  :isUpdatable="false" :nolabel="true"  />
								</template>
								<template v-slot:cell(stockVendor)="row">
									<app-input-textbox :thousandSeparator="true" :id="'input-work-order-supply-sub-contract-detail-stock-vendor-' + row.index" label-cols-lg="12" label="Stock di Vendor" size="sm" :model.sync="row.item.stockVendor"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isEditable="false"  :isUpdatable="false" :nolabel="true"  />
								</template>
								<template v-slot:cell(suggestQty)="row">
									<app-input-textbox :thousandSeparator="true" :id="'input-work-order-supply-sub-contract-detail-suggest-qty-' + row.index" label-cols-lg="12" label="Suggest Supply Qty" size="sm" :model.sync="row.item.suggestQty"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isEditable="false"  :isUpdatable="false" :nolabel="true"  />
								</template>
								<template v-slot:cell(actualQty)="row">
									<app-input-textbox :thousandSeparator="true" :id="'input-work-order-supply-sub-contract-detail-actual-qty-' + row.index" label-cols-lg="12" label="Actual Supply Qty" size="sm" :model.sync="row.item.actualQty"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isEditable="true"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<template v-slot:cell(uoM)="row">
									<app-label label-cols-lg="12" size="sm" label="Uom" :model="(row.item.part != null) ? (row.item.part.uom != null) ? row.item.part.uom.code : null : null"  />
								</template>
								<template v-slot:cell(remarks)="row">
									<app-input-textarea :id="'input-work-order-supply-sub-contract-detail-remarks-' + row.index" label-cols-lg="12" label="Remarks" size="sm" :model.sync="row.item.remarks"  @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isEditable="true"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<template v-slot:cell(actualQtyPicking)="row">
									<app-input-textbox :thousandSeparator="true" :id="'input-work-order-supply-sub-contract-detail-actual-qty-picking-' + row.index" label-cols-lg="12" label="Actual Qty Picking" size="sm" :model.sync="row.item.actualQtyPicking"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isEditable="true"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<template v-slot:cell(qtyPo)="row">
									<app-input-textbox :thousandSeparator="true" :id="'input-work-order-supply-sub-contract-detail-qty-po-' + row.index" label-cols-lg="12" label="Qty PO" size="sm" :model.sync="row.item.qtyPo"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isEditable="true"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<template v-slot:cell(partSubcont)="row">
									<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-work-order-supply-sub-contract-detail-part-subcont-' + row.index" label-cols-lg="12" label="Part Subcont" size="sm" :model.sync="row.item.partSubcontId"  @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :selected="row.item.partSubcont != null ? row.item.partSubcont.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isEditable="true"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<template v-slot:cell(partMappingSubcont)="row">
									<app-input-combobox-autocomplete :options="partMappingSubcontracts" optionsLabel="part" optionsKey="id" :id="'input-work-order-supply-sub-contract-detail-part-mapping-subcont-' + row.index" label-cols-lg="12" label="Part Mapping Subcont" size="sm" :model.sync="row.item.partMappingSubcontId"  @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :selected="row.item.partMappingSubcont != null ? row.item.partMappingSubcont.part : ''"  @input="getPartMappingSubcontracts" :loading="isPartMappingSubcontractComboLoading"  :isEditable="true"  :isUpdatable="true" :nolabel="true"  />
								</template>

								<template v-slot:form-add-detail>
				<WorkOrderSupplySubContractDetailInput 
					:openPopup="isShowPopupWorkOrderSupplySubContractDetail"
					:modelId="workOrderSupplySubContractDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataWorkOrderSupplySubContractDetail"/>
			</template>
			<template v-slot:upload-detail>
				<WorkOrderSupplySubContractDetailUpload
					:openPopup="isShowPopupUploadWorkOrderSupplySubContractDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataWorkOrderSupplySubContractDetail"
					:parentId="modelId"
					/>
				</template>
				<template #row-details="row">
					<b-card>
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
						<app-label label-cols-lg="12" size="sm" label="Part Number WIP" :id="'input-work-order-supply-sub-contract-detail-part-number-wip-' + row.index" :model="(row.item.partSubcont != null) ? row.item.partSubcont.partNumber : null"  />
						<app-input-textbox :id="'input-work-order-supply-sub-contract-detail-qty-outstanding-' + row.index" label-cols-lg="12" label="Qty PO Outstanding" size="sm" :model.sync="row.item.qtyOutstanding"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
						<app-input-textbox :id="'input-work-order-supply-sub-contract-detail-stock-vendor-' + row.index" label-cols-lg="12" label="Stock di Vendor" size="sm" :model.sync="row.item.stockVendor"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
					<app-input-textbox :id="'input-work-order-supply-sub-contract-detail-suggest-qty-' + row.index" label-cols-lg="12" label="Suggest Supply Qty" size="sm" :model.sync="row.item.suggestQty"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
					<app-input-textbox :id="'input-work-order-supply-sub-contract-detail-actual-qty-' + row.index" label-cols-lg="12" label="Actual Supply Qty" size="sm" :model.sync="row.item.actualQty"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
					<app-label label-cols-lg="12" size="sm" label="Uom" :model="(row.item.part != null) ? (row.item.part.uom != null) ? row.item.part.uom.code : null : null"  />
					<app-input-textarea :id="'input-work-order-supply-sub-contract-detail-remarks-' + row.index" label-cols-lg="12" label="Remarks" size="sm" :model.sync="row.item.remarks"  @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
					<app-input-textbox :id="'input-work-order-supply-sub-contract-detail-actual-qty-picking-' + row.index" label-cols-lg="12" label="Actual Qty Picking" size="sm" :model.sync="row.item.actualQtyPicking"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
					<app-input-textbox :id="'input-work-order-supply-sub-contract-detail-qty-po-' + row.index" label-cols-lg="12" label="Qty PO" size="sm" :model.sync="row.item.qtyPo"   @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-work-order-supply-sub-contract-detail-part-subcont-' + row.index" label-cols-lg="12" label="Part Subcont" size="sm" :model.sync="row.item.partSubcontId"  @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :selected="row.item.partSubcont != null ? row.item.partSubcont.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="true" :isEditable="true"  />
					<app-input-combobox-autocomplete :options="partMappingSubcontracts" optionsLabel="part" optionsKey="id" :id="'input-work-order-supply-sub-contract-detail-part-mapping-subcont-' + row.index" label-cols-lg="12" label="Part Mapping Subcont" size="sm" :model.sync="row.item.partMappingSubcontId"  @change="saveInputWorkOrderSupplySubContractDetail(row.item)" :selected="row.item.partMappingSubcont != null ? row.item.partMappingSubcont.part : ''"  @input="getPartMappingSubcontracts" :loading="isPartMappingSubcontractComboLoading"  :isUpdatable="true" :isEditable="true"  />
							</b-card>
						</template>

		</app-table-input-popup>
			<b-overlay :show="isBusy" no-wrap></b-overlay>
			<Portal to="app-inbox-button">
				<app-approval-button
					@approveMethod="submitAction" 
					:showApproveButton="true" 
					approveButtonTitle="Submit Request" 
					@revisionMethod="editDraftAction"
					:showRevisionButton="true"
					revisionButtonTitle="Edit Draft"
					@rejectMethod="discardAction" 
					:showRejectButton="true" 
					rejectButtonTitle="Discard Request" 
				/>
			</Portal>
		</div>
	</div>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import WorkOrderSupplySubContract from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContract';
import WorkOrderSupplySubContractList from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractList';
import WorkOrderSupplySubContractFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractFilter';

import AppInputTextarea from '@/components/AppInputTextarea';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import WosForSubcontractStatus from '@/models/WosForSubcontractStatus/WosForSubcontractStatus';
import WosForSubcontractStatusFilter from '@/filters/WosForSubcontractStatus/WosForSubcontractStatusFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import WorkOrderSupplySubContractDetail from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetail';
import WorkOrderSupplySubContractDetailFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import PartMappingSubcontract from '@/models/PartMappingSubcontract/PartMappingSubcontract';
import PartMappingSubcontractFilter from '@/filters/PartMappingSubcontract/PartMappingSubcontractFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import WorkOrderSupplySubContractDetailInput from '@/views/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetailInput';
import WorkOrderSupplySubContractDetailUpload from '@/views/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetailUpload';

import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import AppApprovalButton from '@/components/AppApprovalButton';

export default {
	props: 
		{
			selectedModelId: {
				default: "",
				type: String
			},
			selectedModel: {
				default: null,
				type: Object
			},
			successAction: {},
			inboxType: {
				default: "",
				type: String
			}
		}
	,
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		WorkOrderSupplySubContractDetailInput,
		WorkOrderSupplySubContractDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail, 
		PopupRouterView,
		AppApprovalButton,
		AppInputTextarea,

		PopupRouterViewApprovalDetail, 
		PopupRouterViewDetail,
		PopupRouterView,
		AppApprovalButton,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},

	data() {
		return {
			errorMessage : {
			},

			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			isShowDataDetailFilter: false,
			isDownloadDataDetail: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			backroute: '',
			approvalConfiguration: {},
			fieldsWorkOrderSupplySubContractDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"part": { "class" : "th-part first-child", "label" : "Part Number", key: 'part', sortable: true }}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: true }}, 
				{"partNumberWip": { "class" : "th-part-number-wip", "label" : "Part Number Wip", key: 'partNumberWip', sortable: false}}, 
				{"qtyOutstanding": { "class" : "th-qty-outstanding last-child", "label" : "Qty PO Outstanding", key: 'qtyOutstanding', sortable: true }}, 
				{"stockVendor": { "class" : "th-stock-vendor d-stack-none", "label" : "Stock di Vendor", key: 'stockVendor', sortable: true }}, 
				{"suggestQty": { "class" : "th-suggest-qty d-stack-none", "label" : "Suggest Supply Qty", key: 'suggestQty', sortable: true }}, 
				{"actualQty": { "class" : "th-actual-qty d-stack-none", "label" : "Actual Supply Qty", key: 'actualQty', sortable: true }}, 
				{"uoM": { "class" : "th-uo-m d-stack-none", "label" : "Uom", key: 'uoM', sortable: true }}, 
				{"remarks": { "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: true }}, 
				// {"actualQtyPicking": { "class" : "th-actual-qty-picking d-stack-none", "label" : "Actual Qty Picking", key: 'actualQtyPicking', sortable: true }}, 
				// {"purchaseOrderDetailId": { "class" : "th-purchase-order-detail-id d-stack-none", "label" : "Purchase Order Detail Id", key: 'purchaseOrderDetailId', sortable: true }}, 
				// {"qtyPo": { "class" : "th-qty-po d-stack-none", "label" : "Qty PO", key: 'qtyPo', sortable: true }}, 
				// {"partSubcont": { "class" : "th-part-subcont d-stack-none", "label" : "Part Subcont", key: 'partSubcont', sortable: true }}, 
				// {"partMappingSubcont": { "class" : "th-part-mapping-subcont d-stack-none", "label" : "Part Mapping Subcont", key: 'partMappingSubcont', sortable: true }}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			modelWorkOrderSupplySubContractDetail : {},
			isShowPopupWorkOrderSupplySubContractDetail : false,
			isShowPopupUploadWorkOrderSupplySubContractDetail : false,
			filterWorkOrderSupplySubContract : null,
			currentWorkOrderSupplySubContractPage : 1,
			workOrderSupplySubContractPageSize: 10,
			sortByWorkOrderSupplySubContract: '',
			sortDescWorkOrderSupplySubContract: '',
			filterWorkOrderSupplySubContractDetail : null,
			currentWorkOrderSupplySubContractDetailPage : 1,
			workOrderSupplySubContractDetailPageSize: 10,
			sortByWorkOrderSupplySubContractDetail: '',
			sortDescWorkOrderSupplySubContractDetail: '',
			sortingByWorkOrderSupplySubContractDetail: [],
			workOrderSupplySubContractDetails : [],
			workOrderSupplySubContractDetailId : '',
			totalWorkOrderSupplySubContractDetailRow : 0,
			isShowWorkOrderSupplySubContractDetailFilter: false,
			isDownloadWorkOrderSupplySubContractDetail: false,
			parts: [],
			partMappingSubcontracts: [],
			purchaseOrders: [],
			purchaseOrders: [],
			isPurchaseOrderComboLoading: false,
			wosForSubcontractStatuss: [],
			wosSubcontStatuss: [],
			isWosSubcontStatusComboLoading: false,
			vendors: [],
			vendors: [],
			isVendorComboLoading: false,
			backroute: '',
			isPurchaseOrderComboLoading: false,
			isWosForSubcontractStatusComboLoading: false,
			isVendorComboLoading: false,
			isWorkOrderSupplySubContractComboLoading: false,
			isPartComboLoading: false,
			isPartMappingSubcontractComboLoading: false,
			minDate: new Date()

		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					console.log("result true");
					result = true;
				}
			});
			return result;
		},
		onPurchaseOrderChange : async function(itemValue) {
			if (itemValue!=null && itemValue!=undefined && this.model.purchaseOrderId==itemValue.id) {
				return;
			}
			if(this.model.purchaseOrderId) {
				let message = "Data Detail akan di reload, apakah anda yakin ingin melanjutkan?";
				if(await this.showPopupWithMessage(message)) {
					await this.generateDetail(itemValue);
				}
			} else {
				await this.generateDetail(itemValue);
			}
		},
		generateDetail : async function(item) {
			this.model.purchaseOrder = item;
			this.model.purchaseOrderId = item.id;

			let result = await WorkOrderSupplySubContract.generateDetail(this, this.model);
			if(result) {
				this.getWorkOrderSupplySubContract(this.model.id);
				this.getWorkOrderSupplySubContractDetails();
			}
		},
		getWorkOrderSupplySubContract : async function(id) {
			this.isDataLoading = true;
			this.getWorkOrderSupplySubContractDetails();

			
			WorkOrderSupplySubContract.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				//WorkOrderSupplySubContract.getApprovalConfigurationInput(this, result.approvalInstanceId).then(result => { this.approvalConfiguration = result; this.isDataLoading = false; }).catch(() => { this.isDataLoading = false; });
				this.isDataLoading = false;
			}).catch(error => { this.isDataLoading = false; });
		},
		downloadData() {
			this.isDownloadWorkOrderSupplySubContract = true;
			this.filterWorkOrderSupplySubContract.id = this.modelId;
			WorkOrderSupplySubContract.downloadDataDetail(this, this.filterWorkOrderSupplySubContract).then(result => {
				this.isDownloadWorkOrderSupplySubContract = false;
			}).catch(error => { this.isDownloadWorkOrderSupplySubContract = false; })
		},
		getWorkOrderSupplySubContractDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderSupplySubContractDetail);
			if (this.modelId == null) return;
			filter.workOrderSupplySubContractId = this.modelId;
			//filter.draftMode = "0";
			if (this.sortByWorkOrderSupplySubContractDetail != null) {
				this.sortingByWorkOrderSupplySubContractDetail[this.sortByWorkOrderSupplySubContractDetail] = this.sortDescWorkOrderSupplySubContractDetail;
			}
			let currentPage = (this.currentWorkOrderSupplySubContractDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderSupplySubContractDetailRow + 1;
				let page = Math.ceil(totalData/this.workOrderSupplySubContractDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderSupplySubContractDetailPageSize = 0;
			// disable paging end
			WorkOrderSupplySubContractDetail.getList(this, filter, this.sortingByWorkOrderSupplySubContractDetail, currentPage , this.workOrderSupplySubContractDetailPageSize).then(result => {
				this.currentWorkOrderSupplySubContractDetailPage = currentPage + 1;
				this.workOrderSupplySubContractDetails = result.data;
				this.totalWorkOrderSupplySubContractDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getWorkOrderSupplySubContracts : async function(input) {
			let filter = new WorkOrderSupplySubContractFilter();
			if (input != undefined) {
				filter.materialIssueNumber = input;
			}
			this.isWorkOrderSupplySubContractComboLoading = true;
			WorkOrderSupplySubContract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContracts = result.data
				}
				this.isWorkOrderSupplySubContractComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getPartMappingSubcontracts : async function(input) {
			let filter = new PartMappingSubcontractFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isPartMappingSubcontractComboLoading = true;
			PartMappingSubcontract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partMappingSubcontracts = result.data
				}
				this.isPartMappingSubcontractComboLoading = false;
			})
			.catch(error => {});
		},
		getPurchaseOrders : async function(input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			PurchaseOrder.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseOrders = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPurchaseOrderExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.purchaseOrderId = null;
				this.model.purchaseOrder = null;
				this.isBusy = true;
				WorkOrderSupplySubContract.resetDocument(this, this.model.id).then(result => {
					this.getWorkOrderSupplySubContract(this.model.id).then(result => {
						this.getWorkOrderSupplySubContractDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.purchaseOrderId = item.id;
				this.model.purchaseOrder = item;

				this.isBusy = true;
				WorkOrderSupplySubContract.copyFromDocument(this, 'purchaseorder', item.id, this.model.id).then(result => {
					this.getWorkOrderSupplySubContract(this.model.id).then(result => {
						this.getWorkOrderSupplySubContractDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedPurchaseOrder(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.purchaseOrderId == itemId) return;
			}

			if(this.workOrderSupplySubContractDetails != null && this.workOrderSupplySubContractDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Work Order Supply Sub Contract akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedPurchaseOrderExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedPurchaseOrderExecuted(item);
			}
		},	
		getWosForSubcontractStatuss : async function(input) {
			let filter = new WosForSubcontractStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			WosForSubcontractStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.wosForSubcontractStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWosSubcontStatus(item) {
			if(item == undefined || item == null) {
				this.model.wosSubcontStatusId = null;
				this.model.wosSubcontStatus = null;
			} else {
				this.model.wosSubcontStatusId = item.id;
				this.model.wosSubcontStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendor(item) {
			if(item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},	
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderSupplySubContract.updateData(this, model, id);
				}
			});
		},
		editDraftAction(modelEvent) {
			let id = this.modelId;
			if(id != '' && id != null && id != undefined) {
				this.$router.push({ name: 'workordersupplysubcontractcreateinboxrequest', params : { id: id } });
			}
		},
		submitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				WorkOrderSupplySubContract.submitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		approveAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to approve this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							WorkOrderSupplySubContract.approveApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		rejectAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to reject this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							WorkOrderSupplySubContract.rejectApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		reviseAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to ask for revision for this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							WorkOrderSupplySubContract.reviseApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		editRequestAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				WorkOrderSupplySubContract.editRequest(this, id).then(result => {
					if (result != null) {
						if (result.id != null && result.id != "") {
							this.$router.push({ name: 'workordersupplysubcontractcreateinboxrequest', params : { id: result.id } });
						}
					}
					this.isCreateBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		discardAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to discard this data?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						WorkOrderSupplySubContract.discardData(this, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				WorkOrderSupplySubContract.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		cancelAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to cancel this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						WorkOrderSupplySubContract.cancelApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		onHidden() {
			// this.getWorkOrderSupplySubContracts();
		},
		addRowDataWorkOrderSupplySubContractDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.workOrderSupplySubContractId =  this.modelId;
					WorkOrderSupplySubContractDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderSupplySubContractDetails(true);
						this.isShowPopupWorkOrderSupplySubContractDetail = false;
					})
				} else {
					model.workOrderSupplySubContractId =  this.modelId;
					WorkOrderSupplySubContractDetail.createData(this, model)
					.then(result => {
						this.getWorkOrderSupplySubContractDetails(true);
						this.isShowPopupWorkOrderSupplySubContractDetail = false;
					})
				}
			}
		},
		async editRowDataWorkOrderSupplySubContractDetail(id) {
			this.workOrderSupplySubContractDetailId = id;
			this.isShowPopupWorkOrderSupplySubContractDetail = true; 
		},
		async deleteRowDataWorkOrderSupplySubContractDetail(id) {
			WorkOrderSupplySubContractDetail.deleteData(this, id).then(result => { this.getWorkOrderSupplySubContractDetails(); });
		},
		async resetDataWorkOrderSupplySubContractDetail() {
			this.workOrderSupplySubContractDetailId = "";
			this.isShowPopupWorkOrderSupplySubContractDetail = true;
		},
		async addDataWorkOrderSupplySubContractDetail() {
			WorkOrderSupplySubContractDetail.createData(this, { workOrderSupplySubContractId: this.modelId })
			.then(result => {
				this.getWorkOrderSupplySubContractDetails(true);
			})
		},
		async addFromClipboardWorkOrderSupplySubContractDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, workOrderSupplySubContractId: this.modelId });
				});
				WorkOrderSupplySubContractDetail.addFromClipboard(this, parts).then(result => { this.getWorkOrderSupplySubContractDetails() });
			});
		},
		async replaceFromClipboardWorkOrderSupplySubContractDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, workOrderSupplySubContractId: this.modelId });
				});
				WorkOrderSupplySubContractDetail.replaceFromClipboard(this, parts).then(result => { this.getWorkOrderSupplySubContractDetails() });
			});   
		},
		showPopupUploadWorkOrderSupplySubContractDetail() {
			this.isShowPopupUploadWorkOrderSupplySubContractDetail = true;
		},
		uploadDataWorkOrderSupplySubContractDetail(modalEvent, newDatas) {
			this.isShowPopupUploadWorkOrderSupplySubContractDetail = false; 
		},
		downloadWorkOrderSupplySubContractDetail(modalEvent) {
			this.isDownloadWorkOrderSupplySubContractDetail = true;
			this.filterWorkOrderSupplySubContractDetail.workOrderSupplySubContractId = this.modelId;
			WorkOrderSupplySubContractDetail.downloadDataDetail(this, this.filterWorkOrderSupplySubContractDetail).then(result => {
				this.isDownloadWorkOrderSupplySubContractDetail = false;
			}).catch(error => { this.isDownloadWorkOrderSupplySubContractDetail = false; })
		},
		saveInputWorkOrderSupplySubContractDetail(item) {
			WorkOrderSupplySubContractDetail.updateDataDetail(this, item, item.id);
		},

		resetModal(modalType) {
			this.isShowPopupUploadWorkOrderSupplySubContractDetail = false; 
			this.isShowPopupWorkOrderSupplySubContractDetail = false; 
			if (modalType == 'WorkOrderSupplySubContractDetail') {
				this.getWorkOrderSupplySubContractDetails();
			}

			//this.showPopupCopyData = false; 
			//this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowWorkOrderSupplySubContractDetailFilter = true;

			}
		},
	},
	beforeMount() {
		//this.filterWorkOrderSupplySubContract = new WorkOrderSupplySubContractFilter();
//this.filterWorkOrderSupplySubContract = new WorkOrderSupplySubContractFilter();
		this.filterWorkOrderSupplySubContractDetail = new WorkOrderSupplySubContractDetailFilter();
		//this.getWorkOrderSupplySubContracts();
		//this.getParts();
		//this.getPartMappingSubcontracts();
		//this.getPurchaseOrders();
		//this.getWosForSubcontractStatuss();
		//this.getVendors();


		//this.getWorkOrderSupplySubContracts();
	},
	async mounted() {
		if (this.selectedModel != null && this.selectedModel != "") {
			this.modelId = this.selectedModel.id;
			this.model = this.selectedModel;
			this.getDataDetails();
		} else if (this.selectedModelId != null && this.selectedModelId != "") {
			this.modelId = this.selectedModelId;
			this.getWorkOrderSupplySubContract(this.selectedModelId);
		}
	},
	computed: {
		disableRejectRevise() {
			if (this.model.approvalRemarks == undefined || this.model.approvalRemarks == null || this.model.approvalRemarks == '') return true;
			return false;
		},
	},
	watch : {
		selectedModelId(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue;
				this.getWorkOrderSupplySubContract(newValue);
			}
		},
		selectedModel(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue.id;
				this.model = newValue;
				this.getWorkOrderSupplySubContractDetails();
			}
		},
		sortByWorkOrderSupplySubContractDetail : {
			handler: function() {
				this.getWorkOrderSupplySubContractDetails();
			}
		},
		sortDescWorkOrderSupplySubContractDetail: {
			handler: function() {
				this.getWorkOrderSupplySubContractDetails();
			}
		},
		currentWorkOrderSupplySubContractDetailPage: {
			handler: function() {
				this.getWorkOrderSupplySubContractDetails();
			}
		},
		workOrderSupplySubContractDetailPageSize : {
			handler: function() {
				this.getWorkOrderSupplySubContractDetails();
			}
		},
		filterWorkOrderSupplySubContractDetail: {
			handler: function() {
				this.getWorkOrderSupplySubContractDetails();
			},
			deep: true,
		},


	},
}
</script>
